// Set ongoing FE error per user redux case to prevent firing duplicate slack notifications (esp from frustrated clicking)
export const SET_FE_ERROR_LOG = 'set_fe_error_log';

// Send slack notification to register FE errors
export const SEND_FE_ERROR_SLACK_MESSAGE_REQUEST = 'send_fe_error_slack_message_request';
export const SEND_FE_ERROR_SLACK_MESSAGE_SUCCESS = 'send_fe_error_slack_message_success';
export const SEND_FE_ERROR_SLACK_MESSAGE_FAILURE = 'send_fe_error_slack_message_failure';